(() => {
  const QUESTIONS = [
    {
      id: "level",
      title: "Level kamu sekarang?",
      desc: "Pilih level yang paling mendekati permainan kamu saat ini.",
      options: [
        { value: "new", label: "Baru Mulai", desc: "Kurang dari 2 bulan main padel." },
        { value: "beginner", label: "Beginner", desc: "Sudah sering social match dan mulai nyaman rally." },
        { value: "intermediate", label: "Intermediate", desc: "Mulai kompetitif / upper beginner / gaya main mulai jelas." },
        { value: "advanced", label: "Advanced / Pro", desc: "Silver++ / rutin turnamen / butuh performa tinggi." }
      ]
    },
    {
      id: "frequency",
      title: "Seberapa sering kamu main padel?",
      desc: "Frekuensi main membantu kami membaca kebutuhan performa.",
      options: [
        { value: "occasional", label: "Kadang-kadang", desc: "1–2x per bulan." },
        { value: "weekly", label: "Rutin mingguan", desc: "1–2x per minggu." },
        { value: "frequent", label: "Sering", desc: "3x atau lebih per minggu." },
        { value: "competitive", label: "Kompetitif / latihan serius", desc: "Sparring, liga, turnamen, atau latihan rutin." }
      ]
    },
    {
      id: "problem",
      title: "Racket sekarang kurangnya di mana?",
      desc: "Pilih problem yang paling terasa saat main.",
      options: [
        { value: "control_out", label: "Bola sering out / susah kontrol", desc: "Butuh racket yang lebih mudah dikontrol." },
        { value: "power_lack", label: "Kurang power / bola kurang keluar", desc: "Butuh bantuan power dan output bola." },
        { value: "tired", label: "Tangan/bahu cepat capek", desc: "Butuh racket yang lebih nyaman dan tidak terlalu demanding." },
        { value: "defense", label: "Susah defense / telat gerak", desc: "Butuh racket yang lebih mudah digerakkan." },
        { value: "upgrade", label: "Racket sekarang sudah oke, mau upgrade", desc: "Butuh performa lebih tinggi." },
        { value: "no_racket", label: "Belum punya racket sendiri", desc: "Butuh pilihan aman untuk mulai." }
      ]
    },
    {
      id: "target",
      title: "Target utama racket baru kamu?",
      desc: "Pilih target utama yang paling kamu cari dari racket baru. Jawaban ini menentukan jenis TOP TARGET yang akan tampil di hasil akhir.",
      options: [
        { value: "power", label: "Top Power", desc: "Balance lebih tinggi dan material cenderung keras, sehingga speed bola lebih cepat dan serangan lebih tajam." },
        { value: "control", label: "Top Control", desc: "Sweetspot lebih aman dan balance lebih rendah, sehingga bola lebih stabil dan mudah diarahkan." },
        { value: "balance", label: "Top Balance", desc: "Karakter racket lebih seimbang, sehingga nyaman dipakai untuk rally, defense, volley, dan attack." },
        { value: "comfort", label: "Top Comfort", desc: "Racket dengan feel lebih lembut dan impact lebih nyaman, sehingga tangan tidak cepat terasa capek saat main." }
      ]
    },
    {
      id: "side",
      title: "Kamu biasa main di sisi mana?",
      desc: "Kalau belum tahu, pilih rotasi.",
      options: [
        { value: "left", label: "Kiri / Left Side", desc: "Point finisher, lebih sering attack dan smash." },
        { value: "right", label: "Kanan / Right Side", desc: "Defender control, build point dan jaga rally." },
        { value: "hybrid", label: "Hybrid / Dua sisi", desc: "Fleksibel attack dan defense." },
        { value: "unknown", label: "Belum tahu / masih rotasi", desc: "Masih cari posisi paling cocok." }
      ]
    },
    {
      id: "behavior",
      title: "Pola main kamu paling mendekati yang mana?",
      desc: "Pilih gaya main yang paling sering muncul.",
      options: [
        { value: "safe_rally", label: "Sabar rally dan cari aman", desc: "Bangun poin stabil dan minim error." },
        { value: "counter_defense", label: "Counter dan defense dulu", desc: "Bertahan dan menunggu momentum." },
        { value: "net_play", label: "Sering maju volley / net play", desc: "Ambil posisi depan dan pressure lawan." },
        { value: "attack_finish", label: "Suka attack dan finish point", desc: "Menyerang, smash, vibora, menyelesaikan poin." },
        { value: "mixed", label: "Campur semua", desc: "Kadang attack, kadang defense." }
      ]
    },
    {
      id: "injury",
      title: "Ada concern tangan, siku, atau bahu?",
      desc: "Ini penting supaya rekomendasi tidak terlalu demanding.",
      options: [
        { value: "none", label: "Tidak ada", desc: "Tidak ada masalah khusus." },
        { value: "tired", label: "Kadang tangan/bahu terasa capek", desc: "Butuh racket lebih nyaman." },
        { value: "elbow_shoulder", label: "Ada concern elbow/shoulder", desc: "Prioritas racket aman dan mudah digunakan." },
        { value: "unknown", label: "Belum tahu", desc: "Sistem akan pilih opsi yang aman." }
      ]
    },
    {
      id: "weight",
      title: "Berat racket yang kamu prefer?",
      desc: "Berat mengikuti range dari brand. Request berat spesifik bisa ditulis saat checkout.",
      options: [
        { value: "light", label: "Ringan", desc: "Di bawah 360g, lebih mudah digerakkan." },
        { value: "medium", label: "Medium", desc: "361–375g, range umum racket padel." },
        { value: "no_pref", label: "Tidak masalah", desc: "Sistem pilih berdasarkan kebutuhan dan gaya main." }
      ]
    },
    {
      id: "budget",
      title: "Budget kamu?",
      desc: "Budget membantu kami pilih rekomendasi yang tetap realistis.",
      options: [
        { value: "under2", label: "Dibawah 2Jt", desc: "Cari pilihan paling worth it di bawah 2 juta." },
        { value: "2to3", label: "2–3Jt", desc: "Range value-performance." },
        { value: "3to5", label: "3–5Jt", desc: "Range premium dengan performa lebih tinggi." },
        { value: "above5", label: "5Jt+", desc: "Top-tier / performance terbaik." },
        { value: "no_limit", label: "Yang penting cocok", desc: "Budget tidak jadi batas utama." }
      ]
    },
    {
      id: "brand",
      title: "Ada brand yang kamu prefer?",
      options: [
        { value: "adidas", label: "Adidas" },
        { value: "bullpadel", label: "Bullpadel"},
        { value: "nox", label: "NOX"},
        { value: "head", label: "Head"},
        { value: "babolat", label: "Babolat"},
        { value: "wilson", label: "Wilson" },
        { value: "siux", label: "Siux"},
        { value: "none", label: "Tidak ada preferensi", desc: "Rekomendasi fokus ke kecocokan." }
      ]
    }
  ];

  const MILLION_CENTS = 1000000 * 100;

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-racket-finder]").forEach(initFinder);
  });

  function initFinder(root) {
    const quiz = root.querySelector("[data-rf-quiz]");
    const questionEl = root.querySelector("[data-rf-question]");
    const resultsEl = root.querySelector("[data-rf-results]");
    const jsonEl = root.querySelector("[data-racket-products-json]");

    let products = [];

    try {
      products = JSON.parse(jsonEl ? jsonEl.textContent : "[]");
    } catch (error) {
      products = [];
    }

    const state = {
      index: 0,
      answers: {},
      top3: []
    };

    quiz.hidden = false;
    resultsEl.hidden = true;
    renderQuestion(root, questionEl, state);

    resultsEl.addEventListener("click", async (event) => {
      const addBtn = event.target.closest("[data-add-cart]");
      const compareBtn = event.target.closest("[data-compare-top]");
      const showMoreBtn = event.target.closest("[data-show-more]");
      const restartBtn = event.target.closest("[data-restart]");
      const chatBtn = event.target.closest("[data-chat-advisor]");

      if (addBtn) {
        await addToCart(addBtn.dataset.addCart, addBtn);
      }

      if (compareBtn) {
        const compare = resultsEl.querySelector("[data-compare-table]");
        if (compare) {
          compare.hidden = !compare.hidden;
          compare.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }

      if (showMoreBtn) {
        resultsEl.querySelectorAll("[data-more-hidden]").forEach((el) => {
          el.hidden = false;
          el.removeAttribute("data-more-hidden");
        });
        showMoreBtn.hidden = true;
      }

      if (restartBtn) {
        state.index = 0;
        state.answers = {};
        state.top3 = [];
        resultsEl.hidden = true;
        quiz.hidden = false;
        renderQuestion(root, questionEl, state);
      }

      if (chatBtn) {
        const url = buildWhatsAppUrl(root, state);
        window.open(url, "_blank");
      }
    });

    root._rfRenderResults = () => {
      renderResults(root, products, state);
    };
  }

  function renderQuestion(root, questionEl, state) {
    const q = QUESTIONS[state.index];
    const progress = Math.round(((state.index + 1) / QUESTIONS.length) * 100);

    root.querySelector("[data-rf-step-label]").textContent = `Step ${state.index + 1} of ${QUESTIONS.length}`;
    root.querySelector("[data-rf-progress-percent]").textContent = `${progress}%`;
    root.querySelector("[data-rf-progress-bar]").style.width = `${progress}%`;

    questionEl.classList.remove("is-sliding-out");
    questionEl.classList.remove("is-sliding-in");

    questionEl.innerHTML = `
      <div class="rf__question-kicker">Racket Finder</div>
      <h2 class="rf__question-title">${escapeHtml(q.title)}</h2>
      <p class="rf__question-desc">${escapeHtml(q.desc || "")}</p>

      <div class="rf__options">
        ${q.options.map((option) => {
          const isSelected = state.answers[q.id] === option.value;

          return `
            <button class="rf__option ${isSelected ? "is-selected" : ""}" type="button" data-answer="${escapeAttr(option.value)}">
              <span class="rf__option-title">${escapeHtml(option.label)}</span>
              <span class="rf__option-desc">${escapeHtml(option.desc || "")}</span>
            </button>
          `;
        }).join("")}
      </div>

      <div class="rf__nav">
        <button class="rf__ghost-btn" type="button" data-back ${state.index === 0 ? "disabled" : ""}>Back</button>
        <button class="rf__ghost-btn" type="button" data-restart-mini>Restart</button>
      </div>
    `;

    requestAnimationFrame(() => {
      questionEl.classList.add("is-sliding-in");
    });

    questionEl.querySelectorAll("[data-answer]").forEach((btn) => {
      btn.addEventListener("touchstart", () => {
        btn.classList.add("is-pressed");
      }, { passive: true });

      btn.addEventListener("touchend", () => {
        btn.classList.remove("is-pressed");
      }, { passive: true });

      btn.addEventListener("touchcancel", () => {
        btn.classList.remove("is-pressed");
      }, { passive: true });

      btn.addEventListener("click", () => {
        state.answers[q.id] = btn.dataset.answer;

        questionEl.querySelectorAll(".rf__option").forEach((optionBtn) => {
          optionBtn.classList.remove("is-selected");
          optionBtn.classList.remove("is-pressed");
          optionBtn.disabled = true;
        });

        btn.classList.add("is-selected");

        setTimeout(() => {
          questionEl.classList.remove("is-sliding-in");
          questionEl.classList.add("is-sliding-out");

          setTimeout(() => {
            if (state.index < QUESTIONS.length - 1) {
              state.index += 1;
              renderQuestion(root, questionEl, state);
            } else {
              const quiz = root.querySelector("[data-rf-quiz]");
              quiz.hidden = true;
              root._rfRenderResults();
            }
          }, 220);
        }, 160);
      });
    });

    const backBtn = questionEl.querySelector("[data-back]");
    if (backBtn) {
      backBtn.addEventListener("click", () => {
        if (state.index > 0) {
          questionEl.classList.remove("is-sliding-in");
          questionEl.classList.add("is-sliding-out");

          setTimeout(() => {
            state.index -= 1;
            renderQuestion(root, questionEl, state);
          }, 220);
        }
      });
    }

    const restartBtn = questionEl.querySelector("[data-restart-mini]");
    if (restartBtn) {
      restartBtn.addEventListener("click", () => {
        state.index = 0;
        state.answers = {};
        renderQuestion(root, questionEl, state);
      });
    }
  }

  function initTopSlider(resultsEl) {
    const slider = resultsEl.querySelector("[data-top-slider]");
    if (!slider) return;

    const track = slider.querySelector("[data-top-track]");
    const slides = Array.from(slider.querySelectorAll("[data-top-slide]"));
    const prevBtn = slider.querySelector("[data-top-prev]");
    const nextBtn = slider.querySelector("[data-top-next]");
    const dots = Array.from(slider.querySelectorAll("[data-top-dot]"));

    if (!track || !slides.length) return;

    let currentIndex = 0;

    function updateSlider() {
      track.style.transform = `translateX(-${currentIndex * 100}%)`;

      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === slides.length - 1;

      dots.forEach((dot, index) => {
        dot.classList.toggle("is-active", index === currentIndex);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        if (currentIndex > 0) {
          currentIndex -= 1;
          updateSlider();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        if (currentIndex < slides.length - 1) {
          currentIndex += 1;
          updateSlider();
        }
      });
    }

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        currentIndex = index;
        updateSlider();
      });
    });

    let startX = 0;
    let deltaX = 0;

    track.addEventListener("touchstart", (event) => {
      startX = event.touches[0].clientX;
      deltaX = 0;
    }, { passive: true });

    track.addEventListener("touchmove", (event) => {
      deltaX = event.touches[0].clientX - startX;
    }, { passive: true });

    track.addEventListener("touchend", () => {
      if (deltaX < -50 && currentIndex < slides.length - 1) {
        currentIndex += 1;
        updateSlider();
      } else if (deltaX > 50 && currentIndex > 0) {
        currentIndex -= 1;
        updateSlider();
      }
    });

    updateSlider();

    // Reset posisi slider kalau layar di-resize lewat breakpoint desktop,
    // supaya grid 3-kolom di desktop nggak kebawa sisa transform dari mode mobile.
    let lastIsDesktop = window.innerWidth > 900;
    window.addEventListener("resize", () => {
      const isDesktop = window.innerWidth > 900;
      if (isDesktop !== lastIsDesktop) {
        lastIsDesktop = isDesktop;
        currentIndex = 0;
        track.style.transform = "";
        updateSlider();
      }
    });
  }

  function renderResults(root, products, state) {
    const resultsEl = root.querySelector("[data-rf-results]");
    resultsEl.hidden = false;

    const scored = products
      .map((product) => scoreProduct(product, state.answers))
      .filter(Boolean)
      .filter((item) => item.customerFit >= 60)
      .sort((a, b) => b.score - a.score);

    if (!products.length) {
      resultsEl.innerHTML = `
        <div class="rf__empty">
          <h2>Collection belum dipilih atau produk belum kebaca.</h2>
          <p>Pilih collection di Theme Editor, lalu pastikan produk punya metafield rating dan inventory aktif.</p>
          <button class="rf__secondary-btn" type="button" data-restart>Restart</button>
        </div>
      `;
      return;
    }

    if (!scored.length) {
      resultsEl.innerHTML = `
        <div class="rf__empty">
          <h2>Belum ada racket yang match dengan jawaban kamu.</h2>
          <p>Kemungkinan produk belum punya metafield lengkap atau belum available.</p>
          <div class="rf__actions">
            <button class="rf__secondary-btn" type="button" data-chat-advisor>Chat Advisor</button>
            <button class="rf__ghost-btn" type="button" data-restart>Ulangi Finder</button>
          </div>
        </div>
      `;
      return;
    }

    const top3 = pickTopRecommendations(scored, state.answers);
    state.top3 = top3;

    const more = scored
      .filter((item) => !top3.some((top) => top.product.id === item.product.id))
      .slice(0, 12);

    resultsEl.innerHTML = `
      <div class="rf__result-header">
        <h2>Rekomendasi Racket untuk Kamu</h2>
        <p>${escapeHtml(buildDynamicSubcopy(state.answers))}</p>
      </div>

      <div class="rf__top-slider" data-top-slider>
        <button class="rf__top-arrow rf__top-arrow--prev" type="button" data-top-prev aria-label="Previous recommendation">
          ←
        </button>

        <div class="rf__top-viewport">
          <div class="rf__top-track" data-top-track>
            ${top3.map((item, index) => `
              <div class="rf__top-slide" data-top-slide>
                ${renderRecommendationCard(item, index, state.answers)}
              </div>
            `).join("")}
          </div>
        </div>

        <button class="rf__top-arrow rf__top-arrow--next" type="button" data-top-next aria-label="Next recommendation">
          →
        </button>

        <div class="rf__top-dots">
          ${top3.map((_, index) => `
            <button
              class="rf__top-dot ${index === 0 ? "is-active" : ""}"
              type="button"
              data-top-dot="${index}"
              aria-label="Go to recommendation ${index + 1}">
            </button>
          `).join("")}
        </div>
      </div>

      <div class="rf__mini-section">
        <h2>Bandingkan Ketiganya</h2>
        <p>Lihat perbandingan power, control, rebound, maneuverability, dan sweetspot dari rekomendasi utama kamu.</p>
        <button class="rf__secondary-btn" type="button" data-compare-top>Bandingkan Top 3</button>

        <div class="rf__table-wrap" data-compare-table hidden>
          ${renderCompareTable(top3)}
        </div>
      </div>

      ${more.length ? `
        <div class="rf__mini-section">
          <h2>Pilihan lain yang juga cocok</h2>
          <p>Masih sesuai dengan jawaban kamu, tapi bukan rekomendasi utama.</p>

          <div class="rf__more-grid">
            ${more.map((item, index) => renderMiniCard(item, index)).join("")}
          </div>

          ${more.length > 4 ? `
            <div style="margin-top:18px;">
              <button class="rf__ghost-btn" type="button" data-show-more>Show More</button>
            </div>
          ` : ""}
        </div>
      ` : ""}

      <div class="rf__mini-section">
        <h2>Masih ragu?</h2>
        <p>Chat advisor padeltop dan kirim hasil rekomendasi kamu untuk dibantu pilih final.</p>
        <div class="rf__actions">
          <button class="rf__secondary-btn" type="button" data-chat-advisor>Chat Advisor</button>
          <button class="rf__ghost-btn" type="button" data-restart>Ulangi Finder</button>
        </div>
      </div>
    `;

    initTopSlider(resultsEl);
  }

  function scoreTargetSpecific(item, target) {
    const p = item.product;
    const power = metric(p, "power_score");
    const control = metric(p, "control_score");
    const rebound = metric(p, "rebound_score");
    const maneuverability = metric(p, "maneuverability_score");
    const sweetspot = metric(p, "sweetspot_score");
    const comfort = deriveComfortScore(p);

    const weights = {
      power:   { power: 0.35, control: 0.10, rebound: 0.30, maneuverability: 0.10, sweetspot: 0.05, comfort: 0.10 },
      control: { power: 0.10, control: 0.35, rebound: 0.10, maneuverability: 0.20, sweetspot: 0.25, comfort: 0 },
      balance: { power: 0.20, control: 0.25, rebound: 0.20, maneuverability: 0.20, sweetspot: 0.15, comfort: 0 },
      comfort: { power: 0.10, control: 0.10, rebound: 0,    maneuverability: 0.25, sweetspot: 0.25, comfort: 0.30 }
    };

    const w = weights[target] || weights.balance;

    return (
      power * w.power +
      control * w.control +
      rebound * w.rebound +
      maneuverability * w.maneuverability +
      sweetspot * w.sweetspot +
      comfort * w.comfort
    ) * 10;
  }

  function pickTopRecommendations(scored, answers) {
    const used = new Set();
    const target = answers.target || "balance";

    const topTargetBadge = {
      power: "TOP POWER",
      control: "TOP CONTROL",
      balance: "TOP BALANCE",
      comfort: "TOP COMFORT"
    }[target] || "TOP TARGET";

    // TOP MATCH — customerFit tertinggi, minimal 70
    const byCustomerFit = [...scored].sort((a, b) => b.customerFit - a.customerFit);
    const topMatch =
      byCustomerFit.find((item) => item.customerFit >= 70) ||
      byCustomerFit[0];

    if (topMatch) used.add(topMatch.product.id);

    // TOP VALUE — Customer Fit 60% + Price/Value 30% + Performance 15%
    const valueCandidates = scored
      .filter((item) => !used.has(item.product.id))
      .filter((item) => item.customerFit >= 70)
      .sort((a, b) => {
        const rank = (x) =>
          x.customerFit * 0.60 +
          affordabilityBoost(x.product.price) * 6 +
          x.budgetFit * 3 +
          performanceAverage(x.product) * 1.5;
        return rank(b) - rank(a);
      });

    const topValue =
      valueCandidates[0] ||
      scored.find((item) => !used.has(item.product.id));

    if (topValue) used.add(topValue.product.id);

    // TOP TARGET — skor tertinggi sesuai target-weighting Q4
    const targetCandidates = scored
      .filter((item) => !used.has(item.product.id))
      .filter((item) => item.customerFit >= 70)
      .sort((a, b) => scoreTargetSpecific(b, target) - scoreTargetSpecific(a, target));

    const topTarget =
      targetCandidates[0] ||
      scored.find((item) => !used.has(item.product.id));

    return [
      topMatch ? { ...topMatch, badge: "TOP MATCH", cardLabel: "Paling cocok buat kamu" } : null,
      topValue ? { ...topValue, badge: "TOP VALUE", cardLabel: "Cocok & paling worth it" } : null,
      topTarget ? { ...topTarget, badge: topTargetBadge, cardLabel: "Paling sesuai target main kamu" } : null
    ].filter(Boolean);
  }

  function scoreProduct(product, answers) {
    if (!product.shopify_available) return null;
    if (product.finder_available === false) return null;
    if (!hasCompleteFinderData(product)) return null;
    if (isJuniorProduct(product)) return null;

    const intent = detectMainIntent(answers);

    const performanceRatingFit = scorePerformanceRatingFit(product, intent);
    const levelFit = scoreLevelFit(product, answers);
    const gameTypeFit = scoreGameTypeFit(product, intent);
    const weightBalanceFit = scoreWeightBalanceFit(product, answers, intent);
    const playStyleFit = scorePlayStyleFit(product, answers, intent);
    const comfortSafetyFit = scoreComfortSafetyFit(product, answers);
    const budgetData = scoreBudget(product, answers);
    const stockPriority = Number(product.stock_priority || 0);
    const brandBoost = getBrandBoost(product, answers);
    const penalty = getPenalty(product, answers, intent, budgetData);

    const customerFit =
      performanceRatingFit +
      levelFit +
      gameTypeFit +
      weightBalanceFit +
      playStyleFit +
      comfortSafetyFit +
      budgetData.score -
      penalty;

    const finalScore =
      customerFit +
      stockPriority +
      brandBoost;

    return {
      product,
      intent,
      score: clamp(Math.round(finalScore), 0, 100),
      customerFit: clamp(Math.round(customerFit), 0, 100),
      performanceRatingFit,
      levelFit,
      gameTypeFit,
      weightBalanceFit,
      playStyleFit,
      comfortSafetyFit,
      budgetFit: budgetData.score,
      stockPriority,
      brandBoost,
      penalty,
      tag: deriveTag(product)
    };
  }

  function scorePlayStyleFit(p, answers, intent) {
    const behavior = answers.behavior;
    const balance = getBalanceGroup(p);
    const power = metric(p, "power_score");
    const control = metric(p, "control_score");
    const maneuverability = metric(p, "maneuverability_score");

    let score = 5;

    if (behavior === "attack_finish") {
      if (intent === "power" || balance === "high") score += 3;
      if (power >= 8.5) score += 2;
    }

    if (behavior === "safe_rally") {
      if (intent === "control" || balance === "balanced" || balance === "low") score += 3;
      if (control >= 8.5) score += 2;
    }

    if (behavior === "counter_defense") {
      if (maneuverability >= 8.5) score += 3;
      if (balance === "low" || balance === "balanced") score += 2;
    }

    if (behavior === "net_play") {
      if (maneuverability >= 8.5) score += 3;
      if (control >= 8.0) score += 2;
    }

    if (behavior === "mixed") {
      if (balance === "balanced") score += 2;
      score += 1;
    }

    return clamp(score, 0, 10);
  }

  function scoreComfortSafetyFit(p, answers) {
    const injury = answers.injury;
    const balance = getBalanceGroup(p);
    const shape = getShapeGroup(p);
    const sweetspot = metric(p, "sweetspot_score");
    const maneuverability = metric(p, "maneuverability_score");

    let score = 5;

    if (injury === "none") {
      return 5;
    }

    if (injury === "tired") {
      if (sweetspot >= 8.5) score += 2;
      if (maneuverability >= 8.5) score += 2;
      if (balance === "high") score -= 2;
      if (shape === "diamond") score -= 1;
    }

    if (injury === "elbow_shoulder") {
      score += (sweetspot - 7) * 0.5;
      score += (maneuverability - 7) * 0.5;
      if (balance === "high") score -= 4;
      if (shape === "diamond") score -= 3;
      if (shape === "round") score += 2;
    }

    if (injury === "unknown") {
      if (sweetspot >= 8.0) score += 1;
      if (balance === "high") score -= 1;
    }

    return clamp(score, 0, 10);
  }

  function hasCompleteFinderData(p) {
    const requiredScores = [
      "power_score",
      "control_score",
      "rebound_score",
      "maneuverability_score",
      "sweetspot_score"
    ];

    const hasScores = requiredScores.every((key) => Number(p[key] || 0) > 0);

    const hasSpecs =
      cleanText(p.level) &&
      cleanText(p.game_type) &&
      cleanText(p.weight) &&
      cleanText(p.balance);

    return hasScores && hasSpecs;
  }

  function isJuniorProduct(p) {
    const text = cleanText([
      p.title,
      p.handle
    ].join(" "));

    return (
      text.includes("junior") ||
      text.includes(" jr ") ||
      text.includes("kids") ||
      text.includes("kid")
    );
  }

  function detectMainIntent(a) {
    // Q4 target adalah driver utama
    if (a.target === "power") return "power";
    if (a.target === "control") return "control";
    if (a.target === "balance") return "balance";
    if (a.target === "comfort") return "comfort";

    // Fallback dari problem/side kalau target belum dijawab
    if (
      a.injury === "tired" ||
      a.injury === "elbow_shoulder" ||
      a.problem === "tired"
    ) {
      return "comfort";
    }

    if (
      a.problem === "control_out" ||
      a.behavior === "safe_rally"
    ) {
      return "control";
    }

    if (
      a.problem === "power_lack" ||
      a.behavior === "attack_finish" ||
      a.side === "left"
    ) {
      return "power";
    }

    if (
      a.problem === "defense" ||
      a.behavior === "counter_defense" ||
      a.behavior === "net_play"
    ) {
      return "control";
    }

    return "balance";
  }

  function scorePerformanceRatingFit(p, intent) {
    const power = metric(p, "power_score");
    const control = metric(p, "control_score");
    const rebound = metric(p, "rebound_score");
    const maneuverability = metric(p, "maneuverability_score");
    const sweetspot = metric(p, "sweetspot_score");
    const comfort = deriveComfortScore(p);

    // Target-weighting per brief §4.1 (kolom ke-6 = comfort derived)
    const weightsByIntent = {
      power: {
        power: 0.35, control: 0.10, rebound: 0.30,
        maneuverability: 0.10, sweetspot: 0.05, comfort: 0.10
      },
      control: {
        power: 0.10, control: 0.35, rebound: 0.10,
        maneuverability: 0.20, sweetspot: 0.25, comfort: 0
      },
      balance: {
        power: 0.20, control: 0.25, rebound: 0.20,
        maneuverability: 0.20, sweetspot: 0.15, comfort: 0
      },
      comfort: {
        power: 0.10, control: 0.10, rebound: 0,
        maneuverability: 0.25, sweetspot: 0.25, comfort: 0.30
      }
    };

    const w = weightsByIntent[intent] || weightsByIntent.balance;

    const decimalScore =
      power * w.power +
      control * w.control +
      rebound * w.rebound +
      maneuverability * w.maneuverability +
      sweetspot * w.sweetspot +
      comfort * w.comfort;

    return decimalScore * 6;
  }

  function scoreLevelFit(p, answers) {
    const productLevel = getLevelGroup(p);
    const userLevel = answers.level;

    if (userLevel === "new") {
      if (productLevel === "sport") return 15;
      if (productLevel === "advance") return 8;
      if (productLevel === "professional") return 2;
    }

    if (userLevel === "beginner") {
      if (productLevel === "sport") return 14;
      if (productLevel === "advance") return 10;
      if (productLevel === "professional") return 4;
    }

    if (userLevel === "intermediate") {
      if (productLevel === "advance") return 15;
      if (productLevel === "sport") return 10;
      if (productLevel === "professional") return 10;
    }

    if (userLevel === "advanced") {
      if (productLevel === "professional") return 15;
      if (productLevel === "advance") return 12;
      if (productLevel === "sport") return 4;
    }

    return 8;
  }

  function scoreGameTypeFit(p, intent) {
    const type = getGameType(p);

    if (intent === "power") {
      if (type === "power") return 10;
      if (type === "allround") return 7;
      if (type === "control") return 3;
    }

    if (intent === "control") {
      if (type === "control") return 10;
      if (type === "allround") return 7;
      if (type === "power") return 3;
    }

    if (intent === "comfort" || intent === "speed") {
      if (type === "control") return 9;
      if (type === "allround") return 8;
      if (type === "power") return 4;
    }

    if (intent === "allround" || intent === "value") {
      if (type === "allround") return 10;
      if (type === "control") return 7;
      if (type === "power") return 7;
    }

    return 6;
  }

  function scoreWeightBalanceFit(p, answers, intent) {
    const avgWeight = getAverageWeight(p);
    const balance = getBalanceGroup(p);

    let score = 6;

    if (answers.weight === "light") {
      if (avgWeight !== null && avgWeight <= 360) score += 2;
      if (balance === "low" || balance === "balanced") score += 2;
      if (balance === "high") score -= 3;
    }

    if (answers.weight === "medium") {
      if (avgWeight !== null && avgWeight > 360 && avgWeight <= 375) score += 2;
      if (balance === "balanced") score += 1;
    }

    if (answers.weight === "no_pref") {
      score += 1;
    }

    if (intent === "power" && balance === "high") score += 2;

    if (
      (intent === "control" || intent === "comfort" || intent === "speed") &&
      balance === "high"
    ) {
      score -= 3;
    }

    if (
      (intent === "control" || intent === "comfort" || intent === "speed") &&
      (balance === "low" || balance === "balanced")
    ) {
      score += 2;
    }

    return clamp(score, 0, 10);
  }

  function scoreBudget(p, a) {
    const price = Number(p.price || 0);

    if (a.budget === "no_limit") {
      return { score: 5, mismatch: false };
    }

    const ranges = {
      under2: [0, 2 * MILLION_CENTS],
      "2to3": [2 * MILLION_CENTS, 3 * MILLION_CENTS],
      "3to5": [3 * MILLION_CENTS, 5 * MILLION_CENTS],
      above5: [5 * MILLION_CENTS, Infinity]
    };

    const range = ranges[a.budget];

    if (!range) return { score: 5, mismatch: false };

    const [min, max] = range;

    if (price >= min && price <= max) {
      return { score: 5, mismatch: false };
    }

    const nearAbove =
      Number.isFinite(max) &&
      price > max &&
      price <= max + 0.5 * MILLION_CENTS;

    if (nearAbove) {
      return { score: 3, mismatch: false };
    }

    return { score: 0, mismatch: true };
  }

  function getPenalty(p, answers, intent, budgetData) {
    let penalty = 0;

    const power = metric(p, "power_score");
    const control = metric(p, "control_score");
    const rebound = metric(p, "rebound_score");
    const maneuverability = metric(p, "maneuverability_score");
    const sweetspot = metric(p, "sweetspot_score");
    const balance = getBalanceGroup(p);
    const shape = getShapeGroup(p);
    const level = getLevelGroup(p);
    const gameType = getGameType(p);

    const controlConcern =
      answers.problem === "control_out" ||
      answers.target === "control" ||
      answers.behavior === "safe_rally";

    const comfortConcern =
      answers.problem === "tired" ||
      answers.target === "comfort" ||
      answers.injury === "tired" ||
      answers.injury === "elbow_shoulder";

    const beginnerSafety =
      answers.level === "new" ||
      answers.problem === "no_racket";

    // Bola sering out + rebound tinggi
    if (controlConcern) {
      if (rebound > 8.3) penalty += 8;
      if (power > 8.3 && control < 8.0) penalty += 10;
      if (balance === "high") penalty += 6;
      if (shape === "diamond") penalty += 5;
    }

    // Concern tangan/siku/bahu + demanding racket
    if (answers.injury === "elbow_shoulder") {
      if (balance === "high") penalty += 12;
      if (shape === "diamond") penalty += 10;
      if (gameType === "power") penalty += 6;
      if (level === "professional") penalty += 8;
    }

    if (comfortConcern && answers.injury !== "elbow_shoulder") {
      if (balance === "high") penalty += 8;
      if (shape === "diamond") penalty += 5;
      if (gameType === "power") penalty += 4;
      if (sweetspot < 7.0) penalty += 8;
      if (maneuverability < 7.0) penalty += 8;
    }

    // Beginner + racket demanding
    if (beginnerSafety) {
      if (level === "professional") penalty += 12;
      if (balance === "high") penalty += 8;
      if (shape === "diamond") penalty += 10;
      if (rebound > 8.3) penalty += 5;
    }

    // Level beginner juga dapat penalty untuk advanced
    if (answers.level === "beginner") {
      if (level === "professional") penalty += 8;
      if (shape === "diamond" && balance === "high") penalty += 6;
    }

    if (answers.side === "left" && intent === "power") {
      if (power < 7.5) penalty += 8;
      if (rebound < 7.5) penalty += 5;
    }

    if (answers.side === "right") {
      if (control < 7.5) penalty += 6;
      if (maneuverability < 7.5) penalty += 6;
    }

    if (answers.level === "intermediate") {
      if (level === "sport" && performanceAverage(p) < 8.0) penalty += 6;
    }

    if (budgetData.mismatch && answers.budget !== "no_limit") {
      penalty += 10;
    }

    return penalty;
  }

  function getBadgeClass(badge) {
    if (badge === "TOP MATCH") return "rf__badge--top-match";
    if (badge === "TOP VALUE") return "rf__badge--top-value";
    return "rf__badge--top-target";
  }

  function getBrandBoost(p, a) {
    if (!a.brand || a.brand === "none") return 0;
    return cleanText(p.brand || p.vendor).includes(a.brand) ? 4 : 0;
  }

  function renderRecommendationCard(item, index, answers) {
    const p = item.product;
    const reasons = buildReasons(item, answers);
    const comparePrice = Number(p.compare_at_price || 0);
    const price = Number(p.price || 0);
    const matchPercent = clamp(item.score, 0, 100);

    return `
      <article class="rf__card">
        <a class="rf__card-image" href="${escapeAttr(p.url)}">
          ${p.image ? `<img src="${escapeAttr(p.image)}" alt="${escapeAttr(p.title)}" loading="lazy">` : ""}
          <span class="rf__badge ${getBadgeClass(item.badge)}">${escapeHtml(item.badge || item.cardLabel)}</span>
          <span class="rf__match">${matchPercent}% cocok</span>
        </a>

        <div class="rf__card-body">
          <span class="rf__tag">${escapeHtml(item.tag)}</span>
          <h3>${escapeHtml(p.title)}</h3>

          <div class="rf__match-bar" aria-label="${matchPercent}% cocok">
            <span style="width:${matchPercent}%"></span>
          </div>

          <div class="rf__price">
            ${formatMoney(price)}
            ${comparePrice > price ? `<span class="rf__compare-price">${formatMoney(comparePrice)}</span>` : ""}
          </div>

          <ul class="rf__reasons">
            ${reasons.map((reason) => `<li>${escapeHtml(reason)}</li>`).join("")}
          </ul>

          <div class="rf__actions">
            <button class="rf__secondary-btn" type="button" data-add-cart="${escapeAttr(p.variant_id)}">
              Add to Cart
            </button>
            <a class="rf__ghost-btn" href="${escapeAttr(p.url)}">
              View Product
            </a>
            ${index === 0 ? `<button class="rf__ghost-btn" type="button" data-chat-advisor>Chat Advisor</button>` : ""}
          </div>
        </div>
      </article>
    `;
  }

  function renderMiniCard(item, index) {
    const p = item.product;
    const hiddenAttr = index >= 4 ? "hidden data-more-hidden" : "";

    return `
      <a class="rf__mini-card" href="${escapeAttr(p.url)}" ${hiddenAttr}>
        ${p.image ? `<img src="${escapeAttr(p.image)}" alt="${escapeAttr(p.title)}" loading="lazy">` : ""}
        <div class="rf__mini-card-body">
          <span class="rf__tag">${escapeHtml(item.tag)}</span>
          <h3>${escapeHtml(p.title)}</h3>
          <div class="rf__price">${item.score}% cocok</div>
          <div>${formatMoney(p.price)}</div>
        </div>
      </a>
    `;
  }

  function renderCompareTable(items) {
    const rows = [
      ["Match Score", ...items.map((item) => `${item.score}%`)],
      ["Best For", ...items.map((item) => item.tag)],
      ["Power", ...items.map((item) => metric(item.product, "power_score").toFixed(1))],
      ["Control", ...items.map((item) => metric(item.product, "control_score").toFixed(1))],
      ["Rebound", ...items.map((item) => metric(item.product, "rebound_score").toFixed(1))],
      ["Maneuverability", ...items.map((item) => metric(item.product, "maneuverability_score").toFixed(1))],
      ["Sweetspot", ...items.map((item) => metric(item.product, "sweetspot_score").toFixed(1))]
    ];

    return `
      <table class="rf__compare-table">
        <thead>
          <tr>
            <th>Metric</th>
            ${items.map((item) => `<th>${escapeHtml(item.badge || item.cardLabel)}<br>${escapeHtml(item.product.title)}</th>`).join("")}
          </tr>
        </thead>
        <tbody>
          ${rows.map((row) => `
            <tr>
              ${row.map((cell) => `<td>${escapeHtml(cell)}</td>`).join("")}
            </tr>
          `).join("")}
        </tbody>
      </table>
    `;
  }

  function buildReasons(item, answers) {
    const p = item.product;
    const reasons = [];

    const targetLabel = getAnswerLabel("target", answers.target);
    const problemLabel = getAnswerLabel("problem", answers.problem);
    const sideLabel = getAnswerLabel("side", answers.side);
    const behaviorLabel = getAnswerLabel("behavior", answers.behavior);

    if (item.badge === "TOP MATCH") {
      const parts = [];
      if (targetLabel) parts.push(`memilih ${targetLabel}`);
      if (problemLabel) parts.push(`masalah utama ${problemLabel.toLowerCase()}`);
      if (sideLabel) parts.push(`main di ${sideLabel.toLowerCase()}`);
      if (parts.length) {
        reasons.push(`Cocok karena kamu ${parts.join(", ")}. Racket ini punya kombinasi atribut paling sesuai dari seluruh jawaban kamu.`);
      }

      if (item.intent === "power") {
        reasons.push(`Power ${metric(p, "power_score").toFixed(1)} dan rebound ${metric(p, "rebound_score").toFixed(1)} mendukung serangan dan output bola lebih kuat.`);
      } else if (item.intent === "control") {
        reasons.push(`Control ${metric(p, "control_score").toFixed(1)} dan sweetspot ${metric(p, "sweetspot_score").toFixed(1)} membantu bola lebih stabil dan mudah diarahkan.`);
      } else if (item.intent === "comfort") {
        reasons.push(`Maneuverability ${metric(p, "maneuverability_score").toFixed(1)} dan sweetspot ${metric(p, "sweetspot_score").toFixed(1)} membantu racket terasa lebih nyaman dan tidak terlalu demanding.`);
      } else if (item.intent === "balance") {
        reasons.push(`Profil seimbang — power ${metric(p, "power_score").toFixed(1)}, control ${metric(p, "control_score").toFixed(1)}, maneuverability ${metric(p, "maneuverability_score").toFixed(1)} — cocok untuk berbagai situasi.`);
      }
    }

    if (item.badge === "TOP VALUE") {
      reasons.push("Pilihan ini tetap cocok dengan jawaban kamu, tapi punya kombinasi harga dan performa yang paling worth it.");
      if (targetLabel) reasons.push(`Sesuai target kamu ${targetLabel} dengan harga yang lebih terjangkau.`);
      if (behaviorLabel) reasons.push(`Cocok untuk gaya main ${behaviorLabel.toLowerCase()}.`);
    }

    if (item.badge && item.badge.startsWith("TOP ") && item.badge !== "TOP MATCH" && item.badge !== "TOP VALUE") {
      // TOP TARGET card
      if (answers.target === "power") {
        reasons.push(`Paling sesuai target utama kamu: ${targetLabel}.`);
        reasons.push(`Balance lebih tinggi, power ${metric(p, "power_score").toFixed(1)} dan rebound ${metric(p, "rebound_score").toFixed(1)} yang agresif untuk serangan lebih tajam.`);
        if (sideLabel) reasons.push(`Cocok untuk main di ${sideLabel.toLowerCase()}.`);
      } else if (answers.target === "control") {
        reasons.push(`Paling sesuai target utama kamu: ${targetLabel}.`);
        reasons.push(`Control ${metric(p, "control_score").toFixed(1)} dan sweetspot ${metric(p, "sweetspot_score").toFixed(1)} yang aman untuk bola lebih stabil dan mudah diarahkan.`);
        if (sideLabel) reasons.push(`Cocok untuk main di ${sideLabel.toLowerCase()} sebagai build point dan jaga rally.`);
      } else if (answers.target === "balance") {
        reasons.push(`Paling sesuai target utama kamu: ${targetLabel}.`);
        reasons.push(`Karakter seimbang dengan power ${metric(p, "power_score").toFixed(1)}, control ${metric(p, "control_score").toFixed(1)}, dan maneuverability ${metric(p, "maneuverability_score").toFixed(1)} — nyaman untuk rally, defense, volley, dan attack.`);
      } else if (answers.target === "comfort") {
        reasons.push(`Paling sesuai target utama kamu: ${targetLabel}.`);
        reasons.push(`Feel lebih lembut, impact lebih nyaman, dan getaran lebih teredam saat rally panjang.`);
        reasons.push(`Sweetspot ${metric(p, "sweetspot_score").toFixed(1)} dan maneuverability ${metric(p, "maneuverability_score").toFixed(1)} membantu tangan tidak cepat capek.`);
      }
    }

    if (reasons.length < 2) {
      reasons.push(`${p.title} punya profil ${item.tag.toLowerCase()} yang sesuai dengan jawaban kamu.`);
    }

    return reasons.slice(0, 4);
  }

  function buildDynamicSubcopy(answers) {
    const parts = [];

    const level = getAnswerLabel("level", answers.level);
    const side = getAnswerLabel("side", answers.side);
    const target = getAnswerLabel("target", answers.target);
    const budget = getAnswerLabel("budget", answers.budget);

    if (level) parts.push(level);
    if (side) parts.push(side);
    if (target) parts.push(target);
    if (budget) parts.push(`budget ${budget}`);

    return `Kami pilih berdasarkan jawaban kamu: ${parts.join(", ")}.`;
  }

  function buildWhatsAppUrl(root, state) {
    const number = String(root.dataset.waNumber || "6285216336699").replace(/\D/g, "");
    const top = state.top3 || [];

    const lines = [
      "Halo padeltop, saya mau konsultasi hasil Racket Finder.",
      "",
      `Jawaban saya: ${buildDynamicSubcopy(state.answers)}`,
      "",
      "Rekomendasi:"
    ];

    top.forEach((item) => {
      lines.push(`- ${item.badge || item.cardLabel}: ${item.product.title} (${item.score}% cocok)`);
    });

    return `https://wa.me/${number}?text=${encodeURIComponent(lines.join("\n"))}`;
  }

  async function addToCart(variantId, button) {
    if (!variantId) return;

    const originalText = button.textContent;
    button.textContent = "Adding...";
    button.disabled = true;

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      });

      if (!response.ok) throw new Error("Add to cart failed");

      button.textContent = "Added";
      window.location.href = "/cart";
    } catch (error) {
      button.textContent = "Failed";
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1600);
    }
  }

  function deriveTag(p) {
    const gameType = getGameType(p);
    const power = metric(p, "power_score");
    const control = metric(p, "control_score");
    const maneuverability = metric(p, "maneuverability_score");
    const sweetspot = metric(p, "sweetspot_score");
    const avg = performanceAverage(p);

    if (gameType === "power" || power >= 8.7) return "Power";
    if (gameType === "control" || control >= 8.7) return "Control";
    if (gameType === "allround") return "All-round";
    if (maneuverability >= 8.7) return "Fast Handling";
    if (sweetspot >= 8.7) return "Easy to Use";
    if (avg >= 8.7) return "Performance";

    return "Recommended";
  }

  function affordabilityBoost(price) {
    price = Number(price || 0);

    if (price <= 2 * MILLION_CENTS) return 5;
    if (price <= 3 * MILLION_CENTS) return 4;
    if (price <= 5 * MILLION_CENTS) return 2;

    return 0;
  }

  function premiumBoost(p) {
    let score = 0;

    if (getLevelGroup(p) === "professional") score += 2;
    if (performanceAverage(p) >= 8.8) score += 2;
    if (metric(p, "power_score") >= 8.8) score += 1;

    return clamp(score, 0, 5);
  }

  function getAnswerLabel(questionId, value) {
    const question = QUESTIONS.find((q) => q.id === questionId);
    const option = question && question.options.find((o) => o.value === value);
    return option ? option.label : "";
  }

  function metric(p, key) {
    return clamp(Number(p[key] || 0), 0, 10);
  }

  function performanceAverage(p) {
    return average([
      metric(p, "power_score"),
      metric(p, "control_score"),
      metric(p, "rebound_score"),
      metric(p, "maneuverability_score"),
      metric(p, "sweetspot_score")
    ]);
  }

  function average(arr) {
    const clean = arr.map(Number).filter((n) => !Number.isNaN(n));

    if (!clean.length) return 0;

    return clean.reduce((sum, n) => sum + n, 0) / clean.length;
  }

  function getLevelGroup(p) {
    const level = cleanText(p.level);

    if (level.includes("sport")) return "sport";
    if (level.includes("advance") || level.includes("advanced")) return "advance";
    if (level.includes("professional") || level.includes("pro")) return "professional";

    return "";
  }

  function getGameType(p) {
    const type = cleanText(p.game_type);

    if (type.includes("power")) return "power";
    if (type.includes("control")) return "control";

    if (
      type.includes("balance") ||
      type.includes("balanced") ||
      type.includes("all round") ||
      type.includes("allround") ||
      type.includes("all")
    ) {
      return "allround";
    }

    return "";
  }

  function getBalanceGroup(p) {
    const balance = cleanText(p.balance);

    // Cek spesifik dulu sebelum generic "heavy"/"light"
    if (balance.includes("handle heavy") || balance.includes("head light")) {
      return "low";
    }

    if (balance.includes("head heavy") || balance.includes("high")) {
      return "high";
    }

    if (
      balance.includes("balance") ||
      balance.includes("balanced") ||
      balance.includes("even") ||
      balance.includes("medium") ||
      balance.includes("low")
    ) {
      return "balanced";
    }

    return "";
  }

  function getShapeGroup(p) {
    const shape = cleanText(p.shape);

    if (shape.includes("diamond")) return "diamond";
    if (shape.includes("teardrop") || shape.includes("tear drop")) return "teardrop";
    if (shape.includes("round")) return "round";

    return "";
  }

  function deriveComfortScore(p) {
    const sweetspot = metric(p, "sweetspot_score");
    const maneuverability = metric(p, "maneuverability_score");
    const balance = getBalanceGroup(p);
    const shape = getShapeGroup(p);

    let score = (sweetspot * 0.5) + (maneuverability * 0.5);

    if (shape === "round") score += 1;
    if (shape === "diamond") score -= 1.5;
    if (balance === "low") score += 1;
    if (balance === "high") score -= 1.5;

    return clamp(score, 0, 10);
  }

  function deriveStabilityScore(p) {
    const rebound = metric(p, "rebound_score");
    const balance = getBalanceGroup(p);
    const level = getLevelGroup(p);

    let score = rebound * 0.6;

    if (balance === "balanced") score += 1.5;
    if (balance === "high") score += 1;
    if (level === "professional") score += 1.5;
    if (level === "advance") score += 0.5;

    return clamp(score, 0, 10);
  }

  function getAverageWeight(p) {
    const matches = cleanText(p.weight).match(/\d+/g);

    if (!matches) return null;

    const nums = matches.map(Number).filter((n) => n >= 300 && n <= 400);

    if (!nums.length) return null;

    return nums.reduce((sum, n) => sum + n, 0) / nums.length;
  }

  function cleanText(value) {
    return String(value || "")
      .toLowerCase()
      .trim()
      .replace(/[_\-/()]/g, " ")
      .replace(/\s+/g, " ");
  }

  function formatMoney(cents) {
    const value = Number(cents || 0) / 100;

    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      maximumFractionDigits: 0
    }).format(value);
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, Number(value) || 0));
  }

  function escapeHtml(value) {
    return String(value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function escapeAttr(value) {
    return escapeHtml(value);
  }
})();
